import { ApiService } from './api.service'
import { CartService } from './cart.service'
import { FavoritesService } from './favorites.service'
import { MainService } from './main.service'

export const services = (gaApp) => ({
  api: new ApiService(gaApp),
  cart: new CartService(gaApp),
  favorites: new FavoritesService(gaApp),
  main: new MainService(gaApp),
})
